import { render, staticRenderFns } from "./AHFeedActions.vue?vue&type=template&id=3e891e94&"
import script from "./AHFeedActions.vue?vue&type=script&lang=ts&"
export * from "./AHFeedActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports